import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=04bd9aee&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04bd9aee')) {
      api.createRecord('04bd9aee', component.options)
    } else {
      api.reload('04bd9aee', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=04bd9aee&", function () {
      api.rerender('04bd9aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y5ZoDM6J7kvH/JS/pricehelp.vue"
export default component.exports